import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SupportPlanController,} from '../../../../api/support/support-plan.controller';
import {SupportCustomerPlanModel} from '../../../../model/support/support-customer-plan.model';
import {SupportPlanTypeEnum} from '../../../../model/support/support-plan-type.enum';
import UpdateCustomerSupportPlanReq = SupportPlanController.UpdateCustomerSupportPlanReq;

type Props = {
  supportPlan: SupportCustomerPlanModel
  refreshSupportPlan: () => Promise<void>
}

export type SupportPlanUpdateDrawerState = {
  planType: SupportPlanTypeEnum
  setPlanType: (value: SupportPlanTypeEnum) => void
  monthlyHours: number
  monthlyHoursDisabled: boolean
  setMonthlyHours: (value: number) => void
  monthlyCost: number
  monthlyCostDisabled: boolean
  setMonthlyCost: (value: number) => void
  translateLocal: (key: string) => string
  translate: (key: string) => string

  handleSubmit: () => Promise<void>
}

export const useSupportPlanUpdateDrawerState = ({supportPlan, refreshSupportPlan}: Props): SupportPlanUpdateDrawerState => {
  const {t} = useTranslation()

  const [planType, setPlanType] = useState<SupportPlanTypeEnum>(supportPlan.planType)
  const [monthlyHours, setMonthlyHours] = useState<number>(supportPlan.monthlyHours)
  const [monthlyCost, setMonthlyCost] = useState<number>(supportPlan.monthlyCost)

  return {
    planType: planType,
    monthlyHours: monthlyHours,
    monthlyCost: monthlyCost,
    monthlyCostDisabled: planType == SupportPlanTypeEnum.BASIC,
    monthlyHoursDisabled: planType == SupportPlanTypeEnum.BASIC || planType === SupportPlanTypeEnum.ADVANCED,
    setPlanType: (planType) => {
      if(planType === SupportPlanTypeEnum.BASIC) {
        setMonthlyHours(4)
        setMonthlyCost(0)
      }
      if(planType === SupportPlanTypeEnum.ADVANCED) {
        setMonthlyHours(10)
      }
      setPlanType(planType)
    },
    setMonthlyHours: setMonthlyHours,
    setMonthlyCost: setMonthlyCost,
    translate: key => t(key),
    translateLocal: key => t(`support-plan-page.plan-update-drawer.${key}`),
    handleSubmit: async () => {
      const request: UpdateCustomerSupportPlanReq = {
        planType: planType,
        monthlyHours: monthlyHours,
        monthlyCost: monthlyCost,
        version: supportPlan.version
      }

      await SupportPlanController.updateCustomerSupportPlan(supportPlan.organizationId, supportPlan.id, request)
      await refreshSupportPlan()
    }
  }
}